import {Appointment} from "@/core/interfaces/Appointment";
import {AgendaAppointment} from "@/core/interfaces/AgendaAppointment";

/**
 * Reshape an appointment read from the patient file (GET
 * customers/{id}/appointments) into the agenda shape, so the file opens the
 * same detail, move and edit dialogs as the calendar.
 *
 * The participants come with their full records there and are reduced to
 * the id and name the agenda carries.
 */
export const toAgendaAppointment = (appointment: Appointment): AgendaAppointment => {
    const {customer, beneficiary, operator} = appointment;

    return {
        id: appointment.id,
        title: appointment.title || null,
        description: appointment.description || null,
        status: appointment.status,
        start_at: appointment.start_at,
        end_at: appointment.end_at,
        location: appointment.location,
        origin: appointment.origin,
        pharmacist_memo: appointment.pharmacist_memo,
        appointment_type: appointment.appointment_type ?? null,
        operator: operator
            ? {id: operator.id, name: operator.name, first_name: operator.first_name, last_name: operator.last_name}
            : null,
        operator_access_point_id: appointment.operator_access_point_id,
        operator_access_point: appointment.operator_access_point,
        customer: customer ? {id: customer.id, name: customer.information?.name ?? null} : null,
        beneficiary: beneficiary ? {id: beneficiary.id, name: beneficiary.information?.name ?? null} : null
    };
};
